import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import menu from '../assets/img/Menu.svg';
import { Link } from 'react-router-dom'
import { Links } from "../util/util";

import { useEffect, useState } from "react";

function NavbarScrollListener() {
    const [listener, setListener] = useState(null);
    const [header, setHeader] = useState(null);

    useEffect(() => {
        if (!listener) {
            setListener(handlePageScroll);
            document.addEventListener("scroll", handlePageScroll);
            handlePageScroll();
        }
        if (!header) {
            const header = document.getElementById("app-navbar");
            if (header) setHeader(header);
        }
        return () => {
            document.removeEventListener("scroll", handlePageScroll);
            if (header) header.classList.remove("scrolled");
        };
    }, [listener]);

    function handlePageScroll() {
        if (!header) return;
        const scrolled = document.scrollingElement.scrollTop;
        if (scrolled >= 160) {
            header.classList.add("scrolled");
        } else {
            header.classList.remove("scrolled");
        }
    }

    return null;
}


export default class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true
        }
    }

    render = () => (
        <div id="app-navbar" className="navbar navbar-expand-lg">
            <div className="navbar-content">
                <div className="container" id='navbar'>
                    <NavLink className="navbar-brand" to={"/"}>
                        <img src={require("../assets/img/logo_black.png")} alt="Firebits logo" />
                    </NavLink>
                    <button
                        className="navbar-toggler"
                        data-toggle="collapse"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={this.props.handleMenuClick}
                    >
                        <img src={menu} alt={'menu'} />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav ml-auto" style={{ alignItems: 'center' }}>
                            <Link to={{ pathname: Links.WORK }} className='item nav-link'>Our Work</Link>
                            <Link to={{ pathname: Links.ABOUT }} className='item nav-link'>About us</Link>
                            <Link to={{ pathname: Links.CONTACT }} className='item nav-link'>Contact</Link>
                            <a className="btn round btn-estimate" href={Links.ESTIMATE_CARD}>
                                Get Estimate
                            </a>
                        </ul>
                    </div>
                </div>
            </div>

            <NavbarScrollListener />
        </div>
    )
}
